import Axios from 'axios';

const bp = '/bp';

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('Token')}`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

const getMultipartHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('Token')}`,
  'Content-Type': 'multipart/form-data',
});

const handleError = (error, success) => {
  success(error.response || error);
};

export const rt_list = (success) =>
  Axios.get(`${bp}/report-template/list/`, { headers: getHeaders() })
    .then(success)
    .catch((e) => handleError(e, success));

export const rt_create = async (data, success) => {
  try {
    const res = await Axios.post(`${bp}/report-template/create/`, data, { headers: getHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};

export const rt_update = async (id, data, success) => {
  try {
    const res = await Axios.put(`${bp}/report-template/update/${id}/`, data, { headers: getHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};

export const rt_delete = async (id, success) => {
  try {
    const res = await Axios.delete(`${bp}/report-template/delete/${id}/`, { headers: getHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};

export const rt_set_default = async (id, success) => {
  try {
    const res = await Axios.patch(`${bp}/report-template/set-default/${id}/`, {}, { headers: getHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};

export const upload_file = async (file, success) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const res = await Axios.post(`${bp}/upload-file/`, formData, { headers: getMultipartHeaders() });
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};

// Dedicated logo upload — requires an existing template id.
// Preserves original file format (SVG stays SVG), stores under media/report-logos/,
// and directly updates header.logo_url on the template record.
// Response: { status, data: { id, header: { logo_url } } }
export const rt_upload_logo = async (templateId, file, success) => {
  try {
    const formData = new FormData();
    formData.append('logo', file);
    const res = await Axios.post(
      `${bp}/report-template/upload-logo/${templateId}/`,
      formData,
      { headers: getMultipartHeaders() }
    );
    success(res);
  } catch (e) {
    handleError(e, success);
  }
};
